function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5637",
  "data-name": "Group 5637",
  transform: "translate(-1199.5 -560.5)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_729",
  "data-name": "Rectangle 729",
  width: 77.322,
  height: 95.766,
  transform: "translate(1199.5 560.5)",
  fill: "rgba(255,255,255,0.1)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_730",
  "data-name": "Rectangle 730",
  width: 77.322,
  height: 90.8,
  transform: "translate(1237.806 583.2)",
  fill: "rgba(255,255,255,0.15)"
}));

function SvgTwoSemiTransparentSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.628,
    height: 113.5,
    viewBox: "0 0 115.628 113.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSemiTransparentSquares);
export default __webpack_public_path__ + "static/media/two-semi-transparent-squares.8840d61e.svg";
export { ForwardRef as ReactComponent };